import React, {useEffect, useState} from "react"
import "./wallets.scss"
import {getWallets, setDefaultOrDeleteWallet} from "services/ecrpyt"
import {useApiDefaults} from "hooks/useApiDefaults"
import Loader from "components/Loader"

const Actions = {
  update: "update",
  delete: "delete"
}

const Wallets = () => {
  const [wallets, setWallets] = useState(null)
  const [loading, setLoading] = useState(false)
  const apiDefualts = useApiDefaults()

  const [action, setAction] = useState("")
  const [walletId, setWalletId] = useState("")
  const [message, setMessage] = useState({
    text: "",
    type: ""
  })

  const fetchWallets = async () => {
    setLoading(true)
    const {data} = await getWallets(apiDefualts)
    setWallets(data)
    setLoading(false)
  }

  useEffect(() => {
    fetchWallets()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function handleSetDefaultOrDeleteClick(wallet_id, action) {
    setMessage({text: "", type: ""})
    
    const {error, message} = await setDefaultOrDeleteWallet({...apiDefualts, wallet_id, action})
    if (error) {
      setMessage({text: message, type: "error"})
    } else {
      setMessage({text: message, type: "success"})
    }

    setAction("")
    setWalletId("")
    fetchWallets()

    setTimeout(() => {
      setMessage({text: "", type: ""})
    }, 3000)
  }

  return (
    <div className="wallets-section-theme2">
      <div className="page-title">
        <h1>Wallets</h1>
      </div>

      <div className="table-wrapper">
        <div className="scrollable">
          {message.text ? <div className={`message ${message.type}-message`}>{message.text}</div> : null}
          <table className="responsive">
            <tbody>
              <tr>
                <th align="left">Card Type</th>
                <th align="left">Account Number</th>
                <th align="left">Expiry</th>
                <th align="center">Action</th>
              </tr>
              {loading ? (
                <tr>
                  <td colSpan={4}>
                    <Loader />
                  </td>
                </tr>
              ) : null}
              {wallets?.map(card => (
                <tr key={card.id} className="table-detail">
                  <td>{card.network}</td>
                  <td>
                    {card.account_number}
                    {card.default ? (
                      <span className="default-badge">Default</span>
                    ) : null}
                  </td>
                  <td>{card.expiry}</td>
                  <td>
                    <div className="action-btn">
                      {card.default ? null : (
                        <button
                          className="defult-btn"
                          disabled={action}
                          onClick={() => {
                            setAction(Actions.update)
                            setWalletId(card.id)
                            handleSetDefaultOrDeleteClick(card.id, Actions.update)
                          }}
                        >
                          {action === Actions.update && walletId === card.id ? "Updating..." : "Set as default"}
                        </button>
                      )}
                      <button
                        className="delete"
                        disabled={action}
                        onClick={() => {
                          setAction(Actions.delete)
                          setWalletId(card.id)
                          handleSetDefaultOrDeleteClick(card.id, Actions.delete)
                        }}
                      >
                        {action === Actions.delete && walletId === card.id ? "Deleting..." : "Delete"}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default Wallets
